'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';

import LoadingAnimation from '@/components/loading-animation';
import { processFacebookOAuthHashReturn } from '@/lib/facebook/process-oauth-hash-return';
import { useToast } from '@/providers/root/toast';

function hasFacebookOAuthHash(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }
    const { hash } = window.location;
    return hash.includes('access_token=') || hash.includes('error=');
}

let hasProcessedFacebookOAuthHash = false;

/**
 * Facebook 移动端 OAuth 回跳到 /login#access_token=... 时统一处理（静态站点无独立 callback 路由）。
 */
export default function FacebookOAuthHashHandler() {
    const router = useRouter();
    const { addToast } = useToast();
    const [isLoading, setIsLoading] = useState(() => hasFacebookOAuthHash());

    useEffect(() => {
        if (hasProcessedFacebookOAuthHash || !hasFacebookOAuthHash()) {
            return;
        }
        hasProcessedFacebookOAuthHash = true;
        setIsLoading(true);

        processFacebookOAuthHashReturn({
            replace: path => router.replace(path),
            onErrorToast: addToast,
        }).finally(() => {
            setIsLoading(false);
        });
    }, [addToast, router]);

    return <LoadingAnimation visible={isLoading} />;
}
